import { checkSceneHasParent } from './check-scene-has-parent.js';
export const ViewHelper = {
    checkSceneHasParent
};
